/**
 * <product-spotlight-card>
 *
 * Wires the size buttons to the hidden variant input inside the card's product
 * form, so the section's add-to-cart posts the size the shopper picked. The
 * form itself is a normal /cart/add submit — cart.js handles the request.
 */
if (!customElements.get('product-spotlight-card')) {
  customElements.define(
    'product-spotlight-card',
    class ProductSpotlightCard extends HTMLElement {
      constructor() {
        super();
        this.onSizeClick = this.onSizeClick.bind(this);
      }

      connectedCallback() {
        this.sizes = Array.from(this.querySelectorAll('[data-spotlight-size]'));
        if (!this.sizes.length) return;

        for (const size of this.sizes) {
          size.addEventListener('click', this.onSizeClick);
        }
      }

      disconnectedCallback() {
        for (const size of this.sizes || []) {
          size.removeEventListener('click', this.onSizeClick);
        }
      }

      get variantInput() {
        return this.querySelector('[data-spotlight-variant-input]');
      }

      get priceElement() {
        return this.querySelector('[data-spotlight-price]');
      }

      onSizeClick(event) {
        const button = event.currentTarget;

        for (const size of this.sizes) {
          size.setAttribute('aria-pressed', String(size === button));
        }

        const input = this.variantInput;
        if (input) input.value = button.dataset.variantId;

        const price = this.priceElement;
        if (price && button.dataset.variantPrice) price.textContent = button.dataset.variantPrice;
      }
    },
  );
}

/**
 * <size-guide-modal>
 *
 * Opens the size chart in a native <dialog>, so focus trapping, Escape and the
 * backdrop come from the platform rather than from us. Only the open, close and
 * click-outside wiring lives here.
 */
if (!customElements.get('size-guide-modal')) {
  customElements.define(
    'size-guide-modal',
    class SizeGuideModal extends HTMLElement {
      constructor() {
        super();
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onDialogClick = this.onDialogClick.bind(this);
      }

      connectedCallback() {
        this.dialog = this.querySelector('[data-size-guide-dialog]');
        this.openButton = this.querySelector('[data-size-guide-open]');
        if (!this.dialog || !this.openButton) return;

        this.closeButton = this.querySelector('[data-size-guide-close]');

        this.openButton.addEventListener('click', this.onOpen);
        this.closeButton?.addEventListener('click', this.onClose);
        this.dialog.addEventListener('click', this.onDialogClick);
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener('click', this.onOpen);
        this.closeButton?.removeEventListener('click', this.onClose);
        this.dialog?.removeEventListener('click', this.onDialogClick);
      }

      onOpen() {
        /* showModal, not show: it is what puts the dialog in the top layer and
           makes the rest of the page inert. */
        this.dialog.showModal();
      }

      onClose() {
        this.dialog.close();
      }

      /* A click on the dialog element itself is a click on its padding box —
         i.e. outside the image — so it closes. Clicks on the image bubble to
         here too, hence the target check. */
      onDialogClick(event) {
        if (event.target === this.dialog) this.dialog.close();
      }
    },
  );
}
